import React, { useEffect } from 'react'
import { Button, TextField, Grid, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1)
	},
	header: {
		textAlign: 'center'
	},
	textField: {
		minWidth: 327
	},
	forgotPassword: {
		color: '#FFFFFF',
		textDecoration: 'none'
	}
}))

export const SignIn = (props) => {
	const classes = useStyles()

	let {
		email,
		setEmail,
		password,
		emailError,
		invalidEmailError,
		passwordError,
		setPassword,
		factorQuestion,
		factorCode,
		setFactorCode,
		submitFactor,
		mfaError,
		resetPassword,
		submittingMFA
	} = props

	return (
		<div>
			<div className={classes.header}>
				<Typography style={{ marginBottom: 8 }} variant="h6">
					Log In
				</Typography>
				<Typography variant="body2">Access your Skipper Admin account</Typography>
			</div>
			<form
				className={classes.form}
				onKeyPress={(e) => {
					if (e && e.key === 'Enter') {
						e.preventDefault()
						props.handleLogin(e)
					}
				}}
				onSubmit={(e) => {
					e.preventDefault()
					props.handleLogin(e)
				}}>
				{!factorQuestion && (
					<TextField
						variant="filled"
						margin="normal"
						fullWidth
						value={email || ''}
						onChange={(e) => setEmail(e.target.value)}
						label="Email"
						autoComplete="email"
						className={classes.textField}
						error={emailError || invalidEmailError}
						helperText={
							emailError ? 'Email is required.' : invalidEmailError ? 'Email is invalid.' : null
						}
					/>
				)}
				{!factorQuestion && (
					<TextField
						variant="filled"
						margin="normal"
						fullWidth
						value={password || ''}
						onChange={(e) => setPassword(e.target.value)}
						type="password"
						label="Password"
						autoComplete="current-password"
						className={classes.textField}
						error={passwordError}
						helperText={passwordError ? 'Password is required.' : null}
					/>
				)}
				{factorQuestion && (
					<TextField
						variant="filled"
						margin="normal"
						fullWidth
						focused
						autoFocus
						value={factorCode || ''}
						onChange={(e) => setFactorCode(e.target.value)}
						label="2-Factor Code"
						className={classes.textField}
						error={mfaError}
						helperText={mfaError ? mfaError : null}
						inputProps={{ maxLength: 6 }}
					/>
				)}
				<Grid container spacing={3}>
					<Grid item xs={6}></Grid>
					<Grid item xs={12}>
						<Button
							disabled={submittingMFA}
							type="submit"
							variant="contained"
							color="secondary"
							fullWidth
							style={{ paddingTop: 10, paddingBottom: 10 }}>
							Log In
						</Button>
					</Grid>
					<Grid item xs={12}>
						<Button
							variant="text"
							color="secondary"
							fullWidth
							disabled={!email || !!invalidEmailError}
							onClick={resetPassword}
							style={{ paddingTop: 10, paddingBottom: 10 }}>
							Forgot Password?
						</Button>
					</Grid>
				</Grid>
				{/* <Grid container>
          <Grid item xs>
            <Link to="/password/reset" className={ classes.forgotPassword } variant="body2">
              Forgot password?
            </Link>
          </Grid>
        </Grid> */}
			</form>
		</div>
	)
}
